/**
 * Do not edit directly, this file was auto-generated.
 *
 * @license Copyright (c) 2022 Red Hat UX MIT License
 */
import { css } from 'lit';
export default css `
:host { color-scheme: inherit; }
:host([color-palette^="dark"]) { color-scheme: only dark; }
:host([color-palette^="light"]) { color-scheme: only light; }
:host([color-palette="lightest"]) { --rh-color-surface: var(--rh-color-surface-lightest, #ffffff); }
:host([color-palette="lighter"]) { --rh-color-surface: var(--rh-color-surface-lighter, #f2f2f2); }
:host([color-palette="light"]) { --rh-color-surface: var(--rh-color-surface-light, #e0e0e0); }
:host([color-palette="dark"]) { --rh-color-surface: var(--rh-color-surface-dark, #383838); }
:host([color-palette="darker"]) { --rh-color-surface: var(--rh-color-surface-darker, #1f1f1f); }
:host([color-palette="darkest"]) { --rh-color-surface: var(--rh-color-surface-darkest, #151515); }`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3ItcGFsZXR0ZS5jc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb2xvci1wYWxldHRlLmNzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUgsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLEtBQUssQ0FBQztBQUFDLGVBQWUsR0FBRyxDQUFBOzs7Ozs7Ozs7bUdBU3NELENBQUMifQ==